import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import { HeaderDiv, DescrDiv, InfoContainer, FlexContainer, OnelinerDiv } from '../styles/div';

export default function About(props) {
    useEffect(() => {
        props.click('about');
      }, [])
    return (<div style={{textAlign: "left", overflowY: "scroll", padding: "2rem",  marginTop: "4rem"}}>
{/* 
    <div style={{padding: "1rem"}}>
    <DescrDiv>Contact us to know more: <a href="mailto:info@cogitarelabs.com?subject=<your query>&body=Hi Team">info@cogitarelabs.com</a></DescrDiv>
    </div> */}


    <InfoContainer>
    <FlexContainer>

        <div style={{flex: 1}}>
        <HeaderDiv><b>Innovating for Mind Upload</b></HeaderDiv>
        {/* <OnelinerDiv></OnelinerDiv> */}
        <DescrDiv>
        <ol>Welcome to Cogitare Labs, where the future is not just imagined, but crafted with care, responsibility, and innovation.</ol>
        </DescrDiv>

        </div>
        </FlexContainer>
    </InfoContainer>

    <InfoContainer>
    <HeaderDiv><b>Our Vision: Mind Upload</b></HeaderDiv>
    {/* <OnelinerDiv><i>"Metaverse built by communities coming from different walks of life"</i></OnelinerDiv> */}
    <DescrDiv>
    <ol>With the advancement of technologies such as Artificial Intelligence, Mixed Reality, Robotics, Brain-Computer Interfaces, Neural Technology, Neuroscience, etc we foresee the potential to achieve infinite digital existence or digital immortality for humans around this mid-century. </ol>
    <ol><b>We are currently focused on bringing like minded people who are passionate about mind upload</b></ol>
    </DescrDiv>
    </InfoContainer>

   <InfoContainer>
    <HeaderDiv><b>Join Us in Our Quest</b></HeaderDiv>
    <DescrDiv>
        <ol>As we continue to push the boundaries of what's possible, we invite you to join us. If you're passionate about mind upload, there's a place for you in the Cogitare Labs story. Let's embark on this exciting journey together and unlock the limitless possibilities of a digital tomorrow.
                    </ol>    
    </DescrDiv>
    </InfoContainer>

    <InfoContainer>
    <HeaderDiv><b>Cogitare Labs: Mind Upload</b></HeaderDiv>
    </InfoContainer>

       <div style={{padding: "1rem"}}>
    <DescrDiv>Please get in touch at <a style={{textDecoration: "underline"}} href="mailto:info@cogitarelabs.com?subject=Apply&body=Hi Team">info@cogitarelabs.com</a></DescrDiv>
    </div>

</div>)
}
